import { RootState } from '..';
import { getNestedField } from '../utils';

export const getUser =
  (state: RootState) =>
    <T extends FlattenKeys<UserState>>(field: T) =>
      getNestedField(state.user, field) as DeepType<UserState, T>;

export const getCurrentUser = (state: RootState) => () =>
  state.user.current_user;
export const getUserId = (state: RootState) => () =>
  getUser(state)('current_user.id');

export const getSelectedClient = (state: RootState) => () =>
  getUser(state)('current_user.clients')?.[0]!;

export const getSelectedFilial = (state: RootState) => () => {
  return (
    getUser(state)('current_user.filials').find(
      ({ id }) => id === state.user.selectedFilialId,
    ) ?? state.user.current_user.filials[0]
  );
};

export const getDashboard = (state: RootState) => () => {
  const kibanaToken = state.auth.kibana.token;
  const key = kibanaToken.key;
  const space = kibanaToken.space;
  const dashboards = state.auth.kibana.dashboards;
  const dashboardId = dashboards[0].id;


  return `http://localhost:5602/s/${space}/app/dashboards#/view/${dashboardId}?embed=true&_g=(refreshInterval%3A(pause%3A!t%2Cvalue%3A60000)%2Ctime%3A(from%3Anow-60m%2Cto%3Anow))`;

  // return `https://kp-${key}.${process.env.REACT_APP_DOMAIN}/s/${space}/app/dashboards#/view/${dashboardId}?embed=true&_g=(refreshInterval%3A(pause%3A!t%2Cvalue%3A60000)%2Ctime%3A(from%3Anow-60m%2Cto%3Anow))`;
};
const includeAction = (action: Actions, actions: Actions | Actions[]) =>
  (Array.isArray(actions) ? actions : [actions]).includes('manage') ||
  (Array.isArray(actions) ? actions : [actions]).includes(action);

const includeSubject = (subject: Subjects, subjects: Subjects | Subjects[]) =>
  (Array.isArray(subjects) ? subjects : [subjects]).includes('all') ||
  (Array.isArray(subjects) ? subjects : [subjects]).includes(subject);

export const getRuleCondition =
  (state: RootState) => (action: Actions, subject: Subjects) => {
    const roles = state.user.current_user.roles;
    const rules = roles.flatMap(({ rules }) => rules);
    const rule = rules.find(
      ({ action: actions, subject: subjects }) =>
        (Array.isArray(actions) ? actions : [actions]).includes(action) &&
        (Array.isArray(subjects) ? subjects : [subjects]).includes(subject),
    ) ?? rules.find(
      ({ action: actions, subject: subjects }) =>
        (Array.isArray(actions) ? actions : [actions]).includes('manage') &&
        (Array.isArray(subjects) ? subjects : [subjects]).includes(subject),
    ) ?? rules.find(
      ({ action: actions, subject: subjects }) =>
        (Array.isArray(actions) ? actions : [actions]).includes(action) &&
        (Array.isArray(subjects) ? subjects : [subjects]).includes('all'),
    ) ?? rules.find(
      ({ action: actions, subject: subjects }) =>
        (Array.isArray(actions) ? actions : [actions]).includes('manage') &&
        (Array.isArray(subjects) ? subjects : [subjects]).includes('all'),
    );
    return rule?.condition as any;
  };

const userGetters = (state: RootState) => ({
  getUser: getUser(state),
  getCurrentUser: getCurrentUser(state),
  getUserId: getUserId(state),
  getSelectedClient: getSelectedClient(state),
  getSelectedFilial: getSelectedFilial(state),
  getRuleCondition: getRuleCondition(state),
  getDashboard: getDashboard(state),
});

export default userGetters;
